import { Injectable, ErrorHandler } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { environment } from "src/environments/environment";

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
    if (!environment.development) {
      Sentry.init({
        dsn: "https://eac93cd2ad144d4293f09dcc34eb5e25@o390927.ingest.sentry.io/5774118",
        integrations: [
          new Integrations.BrowserTracing({
            tracingOrigins: ["localhost", "https://farmertest.soliportal.com/"],
            routingInstrumentation: Sentry.routingInstrumentation,
          }),
        ],

        tracesSampleRate: 1.0,
        maxValueLength: 1000,
        environment: environment.production
          ? "production"
          : environment.staging
          ? "testing"
          : "development",
        release: "solimarket-farmer-dashboard@" + environment.version,
      });
    }
  }

  handleError(error) {
    if (environment.development) {
      Sentry.captureException(error.originalError || error);
    }
    if (environment.development) {
      throw error;
    }
  }
}
